<template>
    <div class="block">
        <h1 class="title">Criteria</h1>

        <div v-show="histogram != null">
            <img :src="histogram" width="400" height="300">
        </div>

        <div class="columns">
            <div class="column"></div>
            <div class="column"><label><input type="radio" v-model="mode" value="log">-Log</label></div>
            <div class="column"><label><input type="radio" v-model="mode" value="conc">Conc</label></div>
            <div class="column"></div>
        </div>
        <div class="range-container">
            <div class="columns" v-show="mode=='conc'">
                <div class="column is-1"></div>
                <div class="column is-2">Positive:</div>
                <div class="column is-2"><input type="text" name="lower" class="range-input" v-bind:value="conc[0]" v-on:change="onLowerConcChanged"></div>
                <div class="column is-1">nM</div>
                <div class="column is-2">Negative:</div>
                <div class="column is-2"><input type="text" name="upper" class="range-input" v-bind:value="conc[1]" v-on:change="onUpperConcChanged"></div>
                <div class="column is-1">nM</div>
                <div class="column is-1"></div>
            </div>
            <div class="columns" v-show="mode=='log'">
                <div class="column is-1">Negative</div>
                <div class="column is-10">
                    <div id="slider"></div>
                </div>
                <div class="column is-1">Positive</div>
            </div>
        </div>

        <CriteriaTable :mode="mode" :criteria="criteria" :counts="counts"></CriteriaTable>
    </div>
</template>

<script>
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
import CriteriaTable from "@/components/CriteriaTable";

export default {
    name: 'CriteriaSelector',
    components: {
        CriteriaTable,
    },
    props: {
        targets: Array,
        types: Object,
        criteria: Array,
    },
    data: function() {
        return {
            slider: null,
            mode: 'log',
            sliderConfig: {
                start: [this.criteria[0], this.criteria[1]],
                connect: [true, false, true],
                step: 0.05,
                range: {
                    'min': [1],
                    'max': [10],
                },
                tooltips: [true, true],
            },
            histogram: null,
            binCounts: null,
            counts: {
                'negative': '-',
                'neutral': '-',
                'positive': '-',
            },
        }
    },
    mounted() {
        this.slider = document.getElementById('slider');
        noUiSlider.create(this.slider, this.sliderConfig);

        let connect = this.slider.querySelectorAll('.noUi-connect');
        let classes = ['lower-slider-color', 'upper-slider-color'];
        for (let i = 0; i < connect.length; i++) {
            connect[i].classList.add(classes[i]);
        }

        const self = this;
        this.slider.noUiSlider.on('update', function (values) {
            self.$emit('changeCriteria', values);
            self.updateCounts();
        });
    },
    watch: {
        criteria: {
            handler: function() {
                let values = this.slider.noUiSlider.get();
                if (this.criteria[0] != values[0] || this.criteria[1] != values[1]) {
                    this.slider.noUiSlider.set(this.criteria);
                }
            },
            deep: true,
        },
        targets: {
            handler: function() {
                this.updateHistogram();
            },
            deep: true,
        },
        types: {
            handler: function() {
                this.updateHistogram();
            },
            deep: true,
        }
    },
    computed: {
        conc: function() {
            return this.criteriaToConc(this.criteria);
        },
    },
    methods: {
        onLowerConcChanged(e) {
            let v = this.concToLog(e.target.value);
            if (v < 0.01) {
                v = 0.01;
            }
            this.$emit('changeCriteria', [this.criteria[0], v]);
        },
        onUpperConcChanged(e) {
            let v = this.concToLog(e.target.value);
            if (v < 0.01) {
                v = 0.01;
            }
            this.$emit('changeCriteria', [v, this.criteria[1]]);
        },
        criteriaToConc(criteria) {
            return [
                this.logToConc(criteria[1]),
                this.logToConc(criteria[0]),
            ];
        },
        concToCriteria(conc) {
            return [
                this.concToLog(conc[1]),
                this.concToLog(conc[0]),
            ];
        },
        logToConc(value) {
            return (Math.pow(10, -1 * value) * Math.pow(10, 9)).toFixed(2);
        },
        concToLog(value) {
            return (-1 * Math.log10(1.0 * value / Math.pow(10, 9))).toFixed(2);
        },
        updateHistogram() {
            const types = this.types;
            let selectedTypes = Object.keys(this.types).filter(function(name) {
                return types[name]
            });
            if (this.targets.length == 0 || selectedTypes.length == 0) {
                this.histogram = null;
                return;
            }
            console.log(this.types);

            let params = 'targets=' + this.targets.join(',')
                + '&'
                + 'types=' + selectedTypes.join(',');
            this.histogram = this.$api_base + '/api/histogram?' + params;

            const self = this;
            this.$axios.get(this.$api_base + '/api/bin-counts?' + params).then(function(response) {
                self.binCounts = response.data;
                self.updateCounts();
            }).catch(function(e) {
                console.log(e);
            });
        },
        updateCounts: function() {
            let low = parseFloat(this.criteria[0]);
            let high = parseFloat(this.criteria[1]);
            this.counts['negative'] = this.getBinCount(0, low);
            this.counts['neutral'] = this.getBinCount(low, high);
            this.counts['positive'] = this.getBinCount(high, 10);
        },
        getBinCount: function(lower, upper) {
            if (!this.binCounts) {
                return 0;
            }
            console.log(this.binCounts);
            let count = 0;
            for (let v in this.binCounts) {
                if (lower <= v && v < upper) {
                    count += parseInt(this.binCounts[v]);
                }
            }
            return count;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.families {
    padding: 10px;
}

.targets {
    padding: 10px;
}

.add {
    margin: 30px;
}

select {
    width: 200px;
}

button {
    width: 120px;
}

.range-container {
    margin-top: 70px;
    height: 100px;
}

.noUi-tooltip {
    display: none;
}
.noUi-active .noUi-tooltip {
    display: block;
}
</style>

<style>
.lower-slider-color {
    background: mistyrose;
}

.upper-slider-color {
    background: #56d296;
}

.range-input {
    width: 100%;
}
</style>
